// extracted by mini-css-extract-plugin
export var card = "teamCard-module--card--Lf8Ji";
export var propic = "teamCard-module--propic--TQfcZ";
export var info = "teamCard-module--info--saVKc";
export var overlay = "teamCard-module--overlay---PD5u";